<template>
  <div class="shipcons-main">
    <Menus :menu="menus" icon="https://dsmlib.logistics.systems/Icons/ShipperConsignee.png" @menuClicked="menuClicked"/>
    <div class="right-container">
      <TableBox title="Shipper/Consignee Profile" :tableData="shipConList" :selectedRow.sync="selectedShipCon" :loading="shipConLoading"/>
    </div>

    <PopupEntry v-if="popupEntryShow" :show.sync="popupEntryShow" :title="popupEntryTitle" :createdBy="createdBy" :updatedBy="updatedBy"
    @save="saveClicked" :requiredError="entryRequired" :successMessages="entrySuccess" :messages="entryMessages" :errorMessages="entryError"
    @requiredClicked="entryRequiredClicked" :viewMode="viewMode" :cancelButton="viewMode ? 'Close' : 'Cancel'">
      <div class="shipcon-code">
        <Input placeholder="Shipper/Consignee Code" :inputValue.sync="shipConCode" :errorMessage.sync="shipConCodeError" :isRequired="true" 
        ref="shipConCode" :isDisabled="viewMode || popupEntryTitle[0] == 'E'" validator="masterfilecode,10,uppercase" />
        <CheckBox title="Active" :isChecked="isActive" :isDisabled="viewMode" />
      </div>

      <Tab :tabs="tabsItems" style="height: calc(100% - 29px)" :tabIndex.sync="currentTab">
        <div slot="General Details" style="display : flex; height : 100%;" > <!-- General Details -->
          <div class="gen-details-right" :style="{ 'width' : (showStatusHistory ? '55%' : '100%'), 'height' : (showStatusHistory ? '35%' : '100%')}">
            <InputQuery :isDisabled="viewMode" placeholder="Shipper/Consignee Category" :isRequired="true" ref="shipcon_category" :items="ShipConCategoryData"
            itemKey="Customer Category - Description" descKey="Customer Category" :selectedObject.sync="selectedShipConCategory" :errorMessage.sync="categoryError" />
            <Input :isDisabled="viewMode" placeholder="Name" :isRequired="true" ref="shipcon_name" :inputValue.sync="shipcon_name" :errorMessage.sync="nameError" validator="text,100,uppercase" />
            <div class="rowBox">
              <Input :isDisabled="viewMode" placeholder="Short Name" :isRequired="true" ref="shipcon_sname" :inputValue.sync="shipcon_sname" :errorMessage.sync="snameError" validator="text,20,uppercase" />
              <InputQuery :isDisabled="viewMode" style="margin: 0 10px 0 10px;" placeholder="Shipper/Consignee Status" :isRequired="true" ref="shipcon_status"
                :items="StatusData" itemKey="Customer Status - Description" descKey="Customer Status" :selectedObject.sync="selectedStatus" :errorMessage.sync="statusError" />
              <DateTimePicker :isDisabled="viewMode" placeholder="From" :value.sync="StatusValidFr"/>
              <button v-if="popupEntryTitle != 'New Shipper/Consignee'" @click="showStatusHistory = true" style="margin: 0 25px; width: 450px;">
                <!-- <img style="width: 25px;  height: 25px;" src="https://dsmlib.logistics.systems/Icons/info-480x480.png"> <br v-if="showStatusHistory"> Status History -->
                Status History
              </button>  
            </div>
            <div class="rowBox">
              <Input :isDisabled="viewMode" placeholder="Comp Reg. No" style="margin: 0 5px 0 0;" :inputValue.sync="ShipCon_RegNo" :errorMessage.sync="regNoError" ref="shipcon_regno" validator="text,20,uppercase" />
              <Input :isDisabled="viewMode" placeholder="Subsidiary of [Parent Co. Name]" style="margin: 0 0 0 5px;" :inputValue.sync="Subsidiary" :errorMessage.sync="subsidiaryError" ref="shipcon_subsidiary" validator="text,20,uppercase" />
            </div>
						<AddressFormV2 :address.sync="addressData" :addressErrors.sync="addressErrors" :viewMode="viewMode" ref="addressForm" :postcodes="postcodes" :states="states" :countries="countries"/>
            <div class="rowBox">
              <Input :isDisabled="viewMode" placeholder="Phone No" style="margin: 0 5px 0 0;" :inputValue.sync="shipcon_phone" :errorMessage.sync="phoneError" ref="shipcon_phone" />
              <Input :isDisabled="viewMode" placeholder="Fax No" style="margin: 0 0 0 5px;" :inputValue.sync="shipcon_fax" :errorMessage.sync="faxError" ref="shipcon_fax" />
            </div>
            <Input :isDisabled="viewMode" placeholder="Email" :inputValue.sync="shipcon_email" :errorMessage.sync="emailError" ref="shipcon_email" />
            <div class="rowBox">
              <InputQuery :isDisabled="viewMode" placeholder="Shipper/Consignee Branch" :items="BrCodeData" itemKey="Branch Code - Branch Name" descKey="Branch Code"
              :selectedObject.sync="selectedBranch" />
              <Dropdown placeholder="SMK FA Code" :items="SMKFACodeData" itemKey="FA Code" :isDisabled="viewMode" :selectedObject.sync="selectedSMKFACode" />
            </div>
          </div>
          <div class="gen-details-left" v-if="showStatusHistory" style="width : 45%; margin : 0 10px 0 20px;">
            <TableBox style="height: 100%;" title="Shipper/Consignee Status History" :tableData="statusHistoryData" />
            <button @click="showStatusHistory = false" style="margin: 10px 0; padding: 10px 30px; float: right;">OK</button>
          </div>
        </div>
        <div slot="Contact Details" style="height: 100%"> <!-- Contact Details -->
          <Contact :person.sync="contactPerson" :contacts.sync="contacts" :viewMode="viewMode" :personError.sync="contactPersonError" ref="contactTab" :postcodes="postcodes" :states="states" :countries="countries"/>
        </div>
        <div slot="Billing Info" style="height: 100%; display: flex"> <!-- Billing Info -->
          <div class="billDetails" :style="{'width' : (billingScheduleShow ? '60%' : '100%')}"> <!-- Left Side -->
            <InputQuery :isDisabled="viewMode" placeholder="Billing Customer Code" ref="shipcon_billcustcode" :items="CustCodeData"
              itemKey="Customer Code - Customer Name" descKey="Customer Code" :selectedObject.sync="selectedCustCode" :errorMessage.sync="custCodeError" />
            <InputQuery :isDisabled="viewMode" placeholder="Payment Type" :items="DefaultPayTypeData" itemKey="Payment Type - Description" descKey="Payment Type"
              :selectedObject.sync="selectedDefaultPayType" />
            <Input :isDisabled="viewMode" placeholder="Bill Term" :inputValue.sync="BillingTerm" :errorMessage.sync="billingTermError" :regex="BillingTermRegex" ref="shipcon_billingterm" />
            <InputQuery :isDisabled="viewMode" placeholder="Bill Type" :items="BillingTypeData" itemKey="Description" descKey="BillType"
              :selectedObject.sync="selectedBillingType" />
            <InputQuery :isDisabled="viewMode" placeholder="Bill Format" :items="BillingFmtData" itemKey="Description" descKey="Billing Fmt"
              :selectedObject.sync="selectedBillingFmt" />
            <InputQuery :isDisabled="viewMode" placeholder="Default Currency" :items="DefaultCurData" itemKey="Currency Code - Description" descKey="Currency Code"
              :selectedObject.sync="selectedDefaultCur" />
            <InputQuery :isDisabled="viewMode" placeholder="GL Acc Code" ref="shipcon_glacccode" :items="Cu_GLAccData" itemKey="Acc No - Description"
              descKey="Acc No" :selectedObject.sync="selectedCu_GLAcc" :errorMessage.sync="glAccCodeError" />
            <CheckBox :isDisabled="viewMode" title="Print Price on CDA" :isChecked.sync="CDAPrintPrice" />
            <InputQuery :isDisabled="viewMode" placeholder="Internal" :items="InternalCustData" itemKey="Description" descKey="InternalCustType"
              :selectedObject.sync="selectedInternalCust" />
            <InputQuery :isDisabled="viewMode" placeholder="Depot Storage Bill" :items="DepotStorageBillTypeData" itemKey="Description"
              descKey="DepotStorageBillType" :selectedObject.sync="selectedDepotStorageBillType" />
            <div class="rowBox">
              <Input :isDisabled="viewMode" class="shortInput" placeholder="Trailer Detention" :inputValue.sync="TrDetFreeDaysOrHrs" :regex="TrDetFreeDaysOrHrsRegex" :errorMessage.sync="TrDetFreeDaysOrHrsError" ref="shipcon_trailerdetention" /> 
              Free Days
            </div>
            <div class="rowBox">
              <Input :isDisabled="viewMode" class="shortInput" placeholder="Trailer Staging" :inputValue.sync="TrkStgFreeDaysOrHrs" :regex="TrkStgFreeDaysOrHrsRegex" :errorMessage.sync="TrkStgFreeDaysOrHrsError" ref="shipcon_trailerstaging" />
              Hours
            </div>
            <div class="rowBox">
              <Input class="shortInput" style="width: 60%;" placeholder="Billing Schedule" :isDisabled="true" :inputValue.sync="billingSchedule" />
              <button :disabled="billingScheduleShow" @click="changeBillingSchedule" v-if="!viewMode">Change Billing Schedule</button>
            </div>
            <InputQuery :isDisabled="viewMode" placeholder="Invoice Option" :items="abInvoiceOptionData" itemKey="Description" descKey="InvoiceOption"
              :selectedObject.sync="selectedabInvoiceOption" />            
          </div>
          <div class="scheduleDetails" v-if="billingScheduleShow" style="margin : 0 20px"> <!-- Right Side -->
            <div class="buttonBox" style="justify-content: flex-end;">
              <button @click="saveBillingSchedule">Save</button>
              <button @click="billingScheduleShow = false" style="margin-left: 5px;">Cancel</button>
            </div>
            <div class="scheduleBox" :style="{ 'border-color' : scheduleSelectionNone ? 'gray' : 'lightgray', 'color' : scheduleSelectionNone ? 'black' : 'lightgray' }">
              <CheckBox class="scheduleTitle" title="None" :isChecked.sync="scheduleSelectionNone" @checkBoxClicked="scheduleSelectionChecked('scheduleSelectionNone')" />
              No billing is done.
            </div>
            <div class="scheduleBox" :style="{ 'border-color' : scheduleSelectionDaily ? 'gray' : 'lightgray', 'color' : scheduleSelectionDaily ? 'black' : 'lightgray' }">
              <CheckBox class="scheduleTitle" title="Daily" :isChecked.sync="scheduleSelectionDaily" @checkBoxClicked="scheduleSelectionChecked('scheduleSelectionDaily')" />
              Billing will be done Daily.
            </div>
            <div class="scheduleBox" :style="{ 'border-color' : scheduleSelectionWeekly ? 'gray' : 'lightgray', 'color' : scheduleSelectionWeekly ? 'black' : 'lightgray' }">
              <CheckBox class="scheduleTitle" title="Weekly" :isChecked.sync="scheduleSelectionWeekly" @checkBoxClicked="scheduleSelectionChecked('scheduleSelectionWeekly')" />
              <div class="weeklyBox" :style="{ 'color' : scheduleSelectionWeekly ? 'black' : 'lightgray' }">
                <CheckBox title="Mon" :isChecked.sync="dayChecked.Monday" :isDisabled="!scheduleSelectionWeekly" @checkBoxClicked="weeklyCheckbox" />
                <CheckBox title="Tue" :isChecked.sync="dayChecked.Tuesday" :isDisabled="!scheduleSelectionWeekly" @checkBoxClicked="weeklyCheckbox" />
                <CheckBox title="Wed" :isChecked.sync="dayChecked.Wednesday" :isDisabled="!scheduleSelectionWeekly" @checkBoxClicked="weeklyCheckbox" />
                <CheckBox title="Thu" :isChecked.sync="dayChecked.Thursday" :isDisabled="!scheduleSelectionWeekly" @checkBoxClicked="weeklyCheckbox" />
                <CheckBox title="Fri" :isChecked.sync="dayChecked.Friday" :isDisabled="!scheduleSelectionWeekly" @checkBoxClicked="weeklyCheckbox" />
                <CheckBox title="Sat" :isChecked.sync="dayChecked.Saturday" :isDisabled="!scheduleSelectionWeekly" @checkBoxClicked="weeklyCheckbox" />
                <CheckBox title="Sun" :isChecked.sync="dayChecked.Sunday" :isDisabled="!scheduleSelectionWeekly" @checkBoxClicked="weeklyCheckbox" />
              </div>
              <Input class="shortInput" style="width: 50%; margin-top: 12px;" placeholder="Days Selected" :inputValue.sync="daysSelected" :isDisabled="true"
                :isRequired="true" :errorMessage.sync="daysSelectedError" />
            </div>
            <div class="scheduleBox" :style="{ 'border-color' : (scheduleSelectionMonthly ? 'gray' : 'lightgray'), 'color' : (scheduleSelectionMonthly ? 'black' : 'lightgray') }">
              <CheckBox class="scheduleTitle" title="Monthly" :isChecked.sync="scheduleSelectionMonthly" @checkBoxClicked="scheduleSelectionChecked('scheduleSelectionMonthly')" />
              <div :style="{ 'color' : (scheduleSelectionMonthly ? 'black' : 'lightgray') }">
                Billing will be done every {{(selectedDay1) ? selectedDay1['CodeValue'] : 'DAY1' }} and {{(selectedDay2) ? selectedDay2['CodeValue'] : 'DAY2' }} of the month.
              </div>
              <Dropdown class="shortInput" style="width: 50%;" placeholder="DAY1" :items="daysData" :isDisabled="!scheduleSelectionMonthly" itemKey="CodeValue"
                :selectedObject.sync="selectedDay1" :isRequired="true" :errorMessage.sync="day1Error" />
              <Dropdown class="shortInput" style="width: 50%;" placeholder="DAY2" :items="daysData" :isDisabled="!scheduleSelectionMonthly" itemKey="CodeValue"
                :selectedObject.sync="selectedDay2" :isRequired="true" :errorMessage.sync="day2Error" />
              <div class="alertBox" :style="{ 'border-color' : (scheduleSelectionMonthly ? '#ff000088' : 'lightgray'), 'color' : (scheduleSelectionMonthly ? '#ff0000' : 'lightgray') }">
                <div class="alertTitle">NOTE</div>
                System will not run auto-billing for months where selected days DO NOT exist.
              </div>
            </div>
            <div class="scheduleBox" :style="{ 'border-color' : (scheduleSelectionQuarterly ? 'gray' : 'lightgray'), 'color' : (scheduleSelectionQuarterly ? 'black' : 'lightgray') }">
              <CheckBox class="scheduleTitle" title="Quarterly" :isChecked.sync="scheduleSelectionQuarterly" @checkBoxClicked="scheduleSelectionChecked('scheduleSelectionQuarterly')" />
              <div :style="{ 'color' : (scheduleSelectionQuarterly? 'black' : 'lightgray') }">
                Every month #{{(selectedQuarter) ? selectedQuarter['CodeValue'] : 'MONTH' }} of each quarter, on day #{{(selectedQuarterDay) ? selectedQuarterDay['CodeValue'] : 'DAY'}} of the month.
              </div>
              <Dropdown class="shortInput" placeholder="MONTH" :items="quarterData" :isDisabled="!scheduleSelectionQuarterly" itemKey="CodeValue"
                :selectedObject.sync="selectedQuarter" :isRequired="true" :errorMessage.sync="quarterError" />
              <Dropdown class="shortInput" placeholder="DAY" :items="daysData" :isDisabled="!scheduleSelectionQuarterly" itemKey="CodeValue"
                :selectedObject.sync="selectedQuarterDay" :isRequired="true" :errorMessage.sync="quarterDayError" />
              <div class="alertBox" :style="{ 'border-color' : (scheduleSelectionQuarterly ? '#ff000088' : 'lightgray'), 'color' : (scheduleSelectionQuarterly ? '#ff0000' : 'lightgray') }">
                <div class="alertTitle">NOTE</div>
                System will not run auto-billing for months where selected days DO NOT exist.
              </div>
            </div>
          </div>
        </div>
        <div slot="Credit Management" style="height: 100%"> <!-- Credit Management -->
          <div class="custCredTop">
            <div class="custCredSection" style="margin: 0 5px 0 0;">
              <InputQuery :isDisabled="viewMode" placeholder="Credit Controller" :items="CreditControllerData" itemKey="Employee" descKey="EmployeeID"
                :selectedObject.sync="selectedCreditController" />
              <Input :isDisabled="viewMode" placeholder="Credit Limit" :inputValue.sync="CreditLimit" :regex="creditLimitRegex" :errorMessage.sync="creditLimitError" ref="shipcon_creditlimit" />
              <Input :isDisabled="viewMode" placeholder="Credit Term" :inputValue.sync="CreditTerm" :regex="creditTermRegex" :errorMessage.sync="creditTermError" ref="shipcon_creditterm" />
              <InputQuery :isDisabled="viewMode" placeholder="Credit Type" :items="CreditTypeData" itemKey="Description" descKey="Credit Type"
                :selectedObject.sync="selectedCreditType" />
              <Input :isDisabled="viewMode" placeholder="Credit Rating" :inputValue.sync="CrRating" :regex="crRatingRegex" :errorMessage.sync="crRatingError" ref="shipcon_creditrating" />
              <Input :isDisabled="viewMode" placeholder="Overdraft Ammount" :inputValue.sync="shipcon_overpay" :regex="shipcon_overpayRegex" :errorMessage.sync="shipcon_overpayError" ref="shipcon_overdraft" />
              <Input :isDisabled="viewMode" placeholder="Cash Float Ammount" :inputValue.sync="shipcon_crdlmt" :regex="shipcon_crdlmtRegex" :errorMessage.sync="shipcon_crdlmtError" ref="shipcon_cashfloat" />
              <Input placeholder="Current Outstanding" :isDisabled="true" :inputValue.sync="CurrentOutStanding" />
            </div>
            <div class="custCredSection" style="margin: 0 0 0 5px;">
              <div class="custCredExtend">
                <div class="custCredExtendTitle">Extended Credit</div>
                <InputQuery :isDisabled="viewMode || extCreditEnabled == false" placeholder="Approved By" :items="ApprovedByData" itemKey="Employee Name" descKey="EmployeeID"
                  :selectedObject.sync="selectedApprovedBy" />
                <Input :isDisabled="viewMode || extCreditEnabled == false" placeholder="Extended Credit Limit" :inputValue.sync="ExtCreditLimit" :regex="creditLimitRegex" :errorMessage.sync="extCreditLimitError" ref="shipcon_extcreditlimit" />
                <Input :isDisabled="viewMode || extCreditEnabled == false" placeholder="Extended Credit Term" :inputValue.sync="ExtCreditTerm" :regex="creditTermRegex" :errorMessage.sync="extCreditTermError" ref="shipcon_extcreditterm" />
                <InputQuery :isDisabled="true" placeholder="Extended Credit Type" :items="CreditTypeData" itemKey="Credit Type" descKey="Description"
                  :selectedObject.sync="selectedCreditType" />
                <div class="rowBox" style="align-items: flex-end;">
                  <div class="custCredExtendDate">
                    <DateTimePicker :isDisabled="viewMode || extCreditEnabled == false" placeholder="Valid From" :value.sync="ValidFr" :maxDate.sync="ValidTo" :errorMessage.sync="validFrError" ref="shipcon_validfrom" />
                    <DateTimePicker :isDisabled="viewMode || extCreditEnabled == false" placeholder="Valid To" :value.sync="ValidTo" :minDate.sync="ValidFr" :errorMessage.sync="validToError" ref="shipcon_validto" />
                  </div>
                  <div class="custCredExtendButtons" style="margin: 0 0 0 20px; display: flex; flex-direction: row;">
                    <button v-if="extCreditEnabled == false && viewMode == false" @click="enableExtCredFields">Extended Credit</button>
                    <button v-if="extCreditEnabled && viewMode == false" @click="applyExtCredFields" style="margin: 0 5px 0 0">Apply</button>
                    <button v-if="extCreditEnabled && viewMode == false" @click="cancelExtCredFields">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TableBox v-if="popupEntryTitle != 'New Shipper/Consignee'" style="height: 100%" title="Extended Credit History" :tableData="AuditExtendedCreditData" />
        </div> 
        <div slot="Sales & Service Team" style="display: flex; height: 100%"> <!-- Sales & Service Team -->
          <div class="shipConSalesDisplay" :style="{ 'width' : (showShipConSalesDetails ? '60%' : ' 100%') }">
            <div v-if="!viewMode">
              <button @click="showShipConSalesDetails = true">+</button>
              <button @click="deleteShipConSales" style="margin-left: 5px;">-</button>
            </div>
            <TableBox style="height: calc(100% - 28px)" :additionalButtons="viewMode ? [] : shipconSalesEditButton" title="Sales & Service Teams" :tableData="SalesServiceData"
              :selectedRow.sync="selectedTeams" @buttonClicked="editShipConSales" :hideColumns="[ 'SalesAction' ]" :maxSelection="-1" />
          </div>
          <div v-if="showShipConSalesDetails" style="width: 40%; margin: 5px 10px;">
            <div style="display: flex; justify-content: flex-end;">
              <button @click="saveTeam">Save</button>
              <button @click="showShipConSalesDetails = false" style="margin-left: 5px;">Cancel</button>
            </div>
            <InputQuery placeholder="Customer System" :isRequired="true" :items="SystemData" itemKey="Application Name" descKey="System" :selectedObject.sync="selectedSystem" :errorMessage.sync="systemError" />
            <InputQuery placeholder="Job Type" :isRequired="true" :items="JobTypeData" itemKey="JobTypeDesc" descKey="JobType" :selectedObject.sync="selectedJobType" :errorMessage.sync="jobTypeError" />
            <InputQuery placeholder="Sales Team" :items="SalesTeamData" itemKey="Sales Team Name" descKey="Sales Team Code" :selectedObject.sync="selectedSalesTeam" />
            <Input placeholder="Sales Person" :inputValue.sync="SalesPerson" :errorMessage.sync="salesPersonError" />
            <InputQuery placeholder="Service Team" :items="ServiceTeamData" itemKey="Service Team Name" descKey="Service Team Code" :selectedObject.sync="selectedServiceTeam" />
            <Input placeholder="Service Person" :inputValue.sync="ServicePerson" :errorMessage.sync="servicePersonError" />
            <CheckBox title="Default" :isChecked.sync="Default" />
          </div>
        </div>
        <div slot="Attachments" style="display: flex; height: 100%"> <!-- Attachments -->
          <Attachments style="width: 100%" :attachments.sync="attachmentsData" :viewMode="viewMode" />
        </div>
        <div slot="GST/SST/eInvoice"> <!-- GST/SST/eInvoice -->
          <GST :viewMode="viewMode" :gstData.sync="gstData" ref="gstTab" />
          <BoxContainer title="SST Details" style="margin-bottom: 20px;">
            <Input placeholder="License No" :inputValue.sync="SSTLicenseNo" :isDisabled="viewMode" ref="SSTLicenseNo" validator="text,50,uppercase" :errorMessage.sync="SSTLicenseNoError"/>
          </BoxContainer>
          <BoxContainer title="LHDN eInvoice Details">
            <div class="lhdn-tin" >
              <button @click="validateTaxPayerTin" :disabled="validateTINIcon != ''" >
                Validate
              </button>
              <div v-if="validateTINIcon != ''" style="margin-right: -5px; margin-left: 5px">
                <Tooltip :icon="validateTINIcon" :tooltipText="validateTINMsg" />
              </div>
              <Input style="margin-left: 5px" placeholder="Tax Identification No (TIN)" :inputValue.sync="eInvoiceTIN" :isDisabled="viewMode" ref="eInvoiceTIN" validator="text,13,uppercase,alphanumeric,none" :errorMessage.sync="eInvoiceTINError"/>
            </div>
          </BoxContainer>
        </div>
      </Tab>
    </PopupEntry>
  </div>
</template>

<script>
/* eslint-disable */
import Contact from '@/components/tabComponents/ContactDetails.vue';
import Attachments from '@/components/tabComponents/Attachments.vue';
import GST from '@/components/tabComponents/GSTDetails.vue';

export default {
  components: {
    Contact, Attachments, GST
  },
  data: function() {
    return {
      menus: [
        { title: 'New Shipper/Consignee', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png', key: "MnuNew", visible: true, enabled: false },
        { title: 'Edit Shipper/Consignee', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png', key: "MnuEdit", visible: true, enabled: false },
        { title: 'Delete Shipper/Consignee', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png' , key: "MnuDelete", visible: false, enabled: false},
        { title: 'View Shipper/Consignee', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png', key: "MnuQuery", visible: true, enabled: false }
      ],

      shipConLoading: false,
      shipConList: [],
      selectedShipCon: [],

      popupEntryShow: false,
      popupEntryTitle: '',
      createdBy: '',
      updatedBy: '',
      viewMode: false,
      entryRequired: [],
      entrySuccess: [],
      entryMessages: [],
      entryError: [],

      shipConCode: '', shipConCodeError: '',
      isActive: false,

      lastUpdate: '',

      tabsItems: [
        {title: 'General Details', disabled: false},
        {title: 'Contact Details', disabled: false},
        {title: 'Billing Info', disabled: false},
        {title: 'Credit Management', disabled: false},
        {title: 'Sales & Service Team', disabled: false},
        {title: 'Attachments', disabled: false},
        {title: 'GST/SST/eInvoice', disabled: false}
      ],
      currentTab: 0,

      errorMapping: [
        { key: 'shipConCode', tab: -1 },
        { key: 'shipcon_category', tab: 0 },
        { key: 'shipcon_name', tab: 0 },
        { key: 'shipcon_sname', tab: 0 },
        { key: 'shipcon_status', tab: 0 },
        { key: 'shipcon_regno', tab: 0 },
        { key: 'shipcon_subsidiary', tab: 0 },
        { key: 'shipcon_addressline1', tab: 0 },
        { key: 'shipcon_addressline2', tab: 0 },
        { key: 'shipcon_addressline3', tab: 0 },
        { key: 'shipcon_addressline4', tab: 0 },
        { key: 'shipcon_city', tab: 0 },
        { key: 'shipcon_phone', tab: 0 },
        { key: 'shipcon_fax', tab: 0 },
        { key: 'shipcon_email', tab: 0 },
        { key: 'shipcon_contact', tab: 1 },
        // { key: 'shipcon_billcustcode', tab: 2 },
        { key: 'shipcon_billingterm', tab: 2 },
        { key: 'shipcon_trailerdetention', tab: 2 },
        { key: 'shipcon_trailerstaging', tab: 2 },
        // { key: 'shipcon_glacccode', tab: 2 },
        { key: 'shipcon_creditlimit', tab: 3 },
        { key: 'shipcon_creditterm', tab: 3 },
        { key: 'shipcon_creditrating', tab: 3 },
        { key: 'shipcon_overdraft', tab: 3 },
        { key: 'shipcon_cashfloat', tab: 3 },
        { key: 'shipcon_extcreditlimit', tab: 3 },
        { key: 'shipcon_extcreditterm', tab: 3 },
        { key: 'shipcon_validfrom', tab: 3 },
        { key: 'shipcon_validto', tab: 3 },
        { key: 'gst_licenseno', tab: 6 },
        { key: 'gst_rmcdapprovalno', tab: 6 },
        { key: 'SSTLicenseNo', tab: 6},
        { key: 'eInvoiceTIN', tab: 6}
      ],

      //#region General Details data
      ShipConCategoryData: [],
      selectedShipConCategory: null, categoryError: '',
      shipcon_name: '', nameError: '',
      shipcon_sname: '', snameError: '',
      StatusData: [],
      selectedStatus: null, statusError: '',
      StatusValidFr: null,
      showStatusHistory: false,
      statusHistoryData: [],
      ShipCon_RegNo: '', regNoError: '',
      Subsidiary: '', subsidiaryError: '',
      addressData: {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: ''
      },
      addressErrors: {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        city: ''
      },
      shipcon_phone: '', phoneError: '',
      shipcon_fax: '', faxError: '',
      shipcon_email: '', emailError: '',
      BrCodeData: [],
      selectedBranch: null,
      SMKFACode: [],
      selectedSMKFACode: null,
      //#endregion

      //#region Contact Details data
      contactPerson: '', contactPersonError: '',
      contacts: [],
      postcodes: [],
      states: [],
      countries: [],

      originalContact: [],
      //#endregion

      //#region Billing Info data
      billingScheduleShow: false,
      CustCodeData: [],
      selectedCustCode: null, //custCodeError: '',
      DefaultGLAccData: [],
      DefaultPayTypeData: [],
      selectedDefaultPayType: null,
      BillingTerm: '', billingTermError: '',
      BillingTermRegex: {
        regex: /\d/g,
        live: true,
        autoClear: false
      },
      BillingTypeData: [],
      selectedBillingType: null,
      BillingFmtData: [],
      selectedBillingFmt: null,
      DefaultCurData: [],
      selectedDefaultCur: null,
      Cu_GLAccData: [],
      selectedCu_GLAcc: null, //glAccCodeError: '',
      CDAPrintPrice: false,
      InternalCustData: [],
      selectedInternalCust: null,
      DepotStorageBillTypeData: [],
      selectedDepotStorageBillType: null,
      TrDetFreeDaysOrHrs: '', TrDetFreeDaysOrHrsError: '',
      TrDetFreeDaysOrHrsRegex: {
        regex: /\d/g,
        live: true,
        autoClear: false
      },
      TrkStgFreeDaysOrHrs: '', TrkStgFreeDaysOrHrsError: '',
      TrkStgFreeDaysOrHrsRegex: {
        regex: /\d/g,
        live: true,
        autoClear: false
      },
      billingSchedule: 'None',
      abInvoiceOptionData: [],
      selectedabInvoiceOption: null,

      scheduleSelectionNone: true,
      scheduleSelectionDaily: false,
      scheduleSelectionWeekly: false,
      dayChecked: {
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
        Sunday: false,
      },
      daysSelected: '',
      daysSelectedError: '',
      scheduleSelectionMonthly: false,
      scheduleSelectionQuarterly: false,
      daysData: [],
      quarterData: [],
      selectedDay1: null,
      selectedDay2: null,
      day1Error: '',
      day2Error: '',
      selectedQuarter: null,
      quarterError: '',
      selectedQuarterDay: null,
      quarterDayError: '',

      billingScheduleCode: '',
      //#endregion

      //#region Credit Management data
      CreditControllerData: [],
      selectedCreditController: null,
      CreditLimit: '', creditLimitError: '',
      creditLimitRegex: {
        regex: /\d*\.?\d*/g,
        live: true,
        autoClear: false
      },
      CreditTerm: '', creditTermError: '',
      creditTermRegex: {
        regex: /\d/g,
        live: true,
        autoClear: false
      },
      CreditTypeData: [],
      selectedCreditType: null,
      CrRating: '', crRatingError: '',
      crRatingRegex: {
        regex: /\d/g,
        live: true,
        autoClear: false
      },
      shipcon_overpay: '', shipcon_overpayError: '',
      shipcon_overpayRegex: {
        regex: /\d*\.?\d*/g,
        live: true,
        autoClear: false
      },
      shipcon_crdlmt: '', shipcon_crdlmtError: '',
      shipcon_crdlmtRegex: {
        regex: /\d*\.?\d*/g,
        live: true,
        autoClear: false
      },
      CurrentOutStanding: '',
      ApprovedByData: [],
      selectedApprovedBy: null,
      extCreditEnabled: false,
      ExtCreditLimit: '', extCreditLimitError: '',
      ExtCreditTerm: '', extCreditTermError: '',
      ExtCreditType: '',
      ValidFr: null,
      validFrError: '',
      ValidTo: null,
      validToError: '',
      AuditExtendedCreditData: [],
      //#endregion

      //#region Sales & Service Team data
      showShipConSalesDetails: false,
      shipconSalesEditButton: [
        { text: 'Edit', index: 0, width: 60 },
        { text: 'Set Default', index: 1, width: 111 },
      ],
      SalesServiceData: [],
      selectedTeams: [],
      SystemData: [],
      selectedSystem: null, systemError: '',
      JobTypeData: [],
      selectedJobType: null, jobTypeError: '',
      SalesTeamData: [],
      selectedSalesTeam: null,
      SalesPerson: '', salesPersonError: '',
      ServiceTeamData: [],
      selectedServiceTeam: null,
      ServicePerson: '', servicePersonError: '',
      Default: false,

      editSalesServiceIndex: -1,
      
      originalSalesService: [],
      //#endregion

      //#region Attachments data
      attachmentsData: [],

      originalAttachments: [],
      //#endregion

      //#region GST/SST/eInvoice data
      gstData: {
        comRegNo: '',
        dateVerified: null,
        licenseNo: '', licenseNoError: '',
        rmcdApprovalNo: '', rmcdApprovalNoError: '',
        taxCodeItems: [],
        selectedTaxCode: null,
      },
      SSTLicenseNo: '',
      SSTLicenseNoError: '',
      eInvoiceTIN: '',
      eInvoiceTINError: '',
      validateTINIcon: '',
      validateTINMsg: 'Not Validated',
      custType: "1"
      //#endregion
    }
  },
  methods: {
    menuClicked: async function(e) {
      this.clearTabFields();
      this.clearEntryMessages();

      switch (e['title']) {
        case 'New Shipper/Consignee':
          this.popupEntryShow = true;
          this.popupEntryTitle = "New Shipper/Consignee";
          this.updatedBy = '';
          this.createdBy = '';
          break;
        case 'Edit Shipper/Consignee':
          if (this.selectedShipCon.length == 0) {
            this.$showAlert('error', 'No Shipper/Consignee Selected', 'Please select a shipper/consignee to edit')
          } else {
            this.popupEntryShow = true;
            this.popupEntryTitle = "Edit Shipper/Consignee";

            await this.populateShipConDetails(this.selectedShipCon[0]['Customer Code']);
          }
          break;
        case 'View Shipper/Consignee':
          if (this.selectedShipCon.length == 0) {
            this.$showAlert('error', 'No Shipper/Consignee Selected', 'Please select a shipper/consignee to view')
          } else {
            this.popupEntryShow = true;
            this.popupEntryTitle = "View Shipper/Consignee";
            this.viewMode = true;

            await this.populateShipConDetails(this.selectedShipCon[0]['Customer Code']);
          }
          break;  
        case 'Delete Shipper/Consignee':
          if (this.selectedShipCon.length == 0) {
            this.$showAlert('error', 'No Shipper/Consignee Selected', 'Please select a shipper/consignee to delete')
          } else {
            let deleting = await this.$showAlert('warning', 'Delete Shipper/Consignee', `Are you sure you want to delete shipper/consignee ${this.selectedShipCon[0]['Customer Code']}?`,   //************
            [
              { text: 'Delete', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ]);

            if (deleting == 'Delete') {
              let result = await this.$apiCallV2('/ShipperConsignee/SaveShipperConsignee', {
                action: 'D',
                cu_number: this.selectedShipCon[0]['Customer Code']
              });

              if (result[0]['Results'] == 0) {  // delete successful
                this.$showAlert('success', 'Shipper/Consignee Deleted', `Successfully deleted shipper/consignee ${result[0]['cu_number']}`);

                this.shipConList = [];
                this.selectedShipCon = [];
                this.$nextTick(async () => await this.getShippersConsignees());
              } else {  // deletion error
                this.$showAlert('error', 'Shipper/Consignee NOT Deleted', `There was an error deleting your shipper/consignee: ${result[0]['ErrMsg']}`);
              }
            }
          }
          break; 
      }
    },
    getShippersConsignees: async function() {
      this.shipConLoading = true;
      const shipCon = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'shipperconsignee' });
      this.shipConList = shipCon.map((item) => {
          return {
            ...item,
            "Customer Code - Customer Name": `${item['Customer Code']} - ${item['Customer Name']}`,
          };
        });
      this.shipConLoading = false;
    },
    getBillingCustomer: async function() {
      const billCust = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'BILLCUST' });
      this.CustCodeData = billCust.map((item) => {
          return {
            ...item,
            "Customer Code - Customer Name": `${item['Customer Code']} - ${item['Customer Name']}`,
          };
        });
    },
    getShippersConsignees2: async function() {
      this.shipConLoading = true;
      
      this.$fullscreenLoading('Getting Shippers/Consignees');
      this.shipConList = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'shipperconsignee' });
      this.$fullscreenLoading();
      this.shipConLoading = false;
    },
    populateShipConDetails: async function(shipcon) {
      this.$fullscreenLoading('Getting Details');
      let details = await this.$apiCallV2('/ShipperConsignee/GetDetailsMaster', {
        'masterfile': 'shipperconsignee',
        'module': 'MASTER',
        'recordid': shipcon
      });
      details = details['Customer'];
      this.$fullscreenLoading('Getting Attachments');
      let attachments = await this.$apiCallV2(`/ShipperConsignee/GetMasterFileAttachments?refno=${shipcon}&tablename=CUSTOMER`);
      attachments.forEach(a => {
        a['FileName'] = a['File Name'];
        delete a['File Name'];
      });

      this.shipConCode = this.populateTextTrim(details['cu_number']);
      this.isActive = details['Status'] == 'A';

      this.lastUpdate = details['DateUpdate'];
      this.createdBy = `${details['UserCreated']} ${this.$dateTime.getDateTime(new Date(details['TimeCreated']), 'dd/MM/yyyy HH:mm')}`;
      this.updatedBy = `${details['UserID'].trim()} ${this.$dateTime.getDateTime(new Date(details['DateUpdate']), 'dd/MM/yyyy HH:mm')}`;

      //#region populate General Details tab
      this.selectedShipConCategory = this.populateObject(this.ShipConCategoryData, 'Customer Category', details['CustCategory']);
      this.shipcon_name = this.populateTextTrim(details['cu_name']);
      this.shipcon_sname = this.populateTextTrim(details['cu_sname']);
      this.selectedStatus = this.populateObject(this.StatusData, 'Customer Status', details['Status']);
      this.StatusValidFr = details['StatusValidFr'] ? new Date(details['StatusValidFr']) : null; // Need to focus if there is data

      this.statusHistoryData = details['CustomerStatus'] ? Array.isArray(details['CustomerStatus']) ? details['CustomerStatus'] : [details['CustomerStatus']] : [];
      this.statusHistoryData.forEach(data => {
        data['Valid From'] = data['Valid From'] ? this.$dateTime.getDateTime(new Date(data['Valid From']), 'dd/MM/yyyy HH:mm') : null;
        data['Valid To'] = data['Valid To'] ? this.$dateTime.getDateTime(new Date(data['Valid To']), 'dd/MM/yyyy HH:mm') : null;
      });
      this.statusHistoryData = this.statusHistoryData;

      this.ShipCon_RegNo = this.populateTextTrim(details['Cus_RegNo']);
      this.Subsidiary = this.populateTextTrim(details['Subsidiary']);
      this.addressData['addressLine1'] = this.populateTextTrim(details['cu_addr1']);
      this.addressData['addressLine2'] = this.populateTextTrim(details['cu_addr2']);
      this.addressData['addressLine3'] = this.populateTextTrim(details['cu_addr3']);
      this.addressData['addressLine4'] = this.populateTextTrim(details['cu_addr4']);
      this.addressData['postcode'] = this.populateTextTrim(details['Postcode']);
      this.addressData['city'] = this.populateTextTrim(details['City']);
      this.addressData['state'] = this.populateTextTrim(details['State']);
      this.addressData['country'] = this.populateTextTrim(details['Country']);
      this.shipcon_phone = this.populateTextTrim(details['cu_phone']);
      this.shipcon_fax = this.populateTextTrim(details['cu_fax']);
      this.shipcon_email = this.populateTextTrim(details['cu_email']);
      this.selectedBranch = this.populateObject(this.BrCodeData, 'Branch Code', details['BrCode']);
      this.selectedSMKFACode = this.populateObject(this.SMKFACodeData, 'FA Code', details['SMKFACode']); 
      //#endregion

      //#region populate Contact Details tab
      this.contactPerson = this.populateTextTrim(details['cu_contact']);
      this.contacts = details['Contact'] ? Array.isArray(details['Contact']) ? details['Contact'] : [details['Contact']] : [];
      this.contacts.forEach(data => {
        data['DateUpdate'] = data['DateUpdate'] ? this.$dateTime.getDateTime(new Date(data['DateUpdate']), 'dd/MM/yyyy HH:mm') : null;
      });
      this.contacts = this.contacts;
      this.contacts.forEach(c => this.originalContact.push(c));
      //#endregion

      //#region populate Billing Info tab
      this.selectedCustCode = this.populateObject(this.CustCodeData, 'Customer Code', details['cu_BillTo']);
      this.selectedDefaultPayType = this.populateObject(this.DefaultPayTypeData, 'Payment Type', details['DefaultPayType']);
      this.BillingTerm = this.populateTextTrim(details['BillingTerm']);
      this.selectedBillingType = this.populateObject(this.BillingTypeData, 'BillType', details['BillingType']);
      this.selectedBillingFmt = this.populateObject(this.BillingFmtData, 'Billing Fmt', details['BillingFmt']);
      this.selectedDefaultCur = this.populateObject(this.DefaultCurData, 'Currency Code', details['DefaultCur']);
      this.selectedCu_GLAcc = this.populateObject(this.Cu_GLAccData, 'Acc No', details['Cu_GLAcc']);
      this.CDAPrintPrice = details['CDAPrintPrice'] == '1';
      this.selectedInternalCust = this.populateObject(this.InternalCustData, 'InternalCustType', details['InternalCust']);
      this.selectedDepotStorageBillType = this.populateObject(this.DepotStorageBillTypeData, 'DepotStorageBillType', details['DepotStorageBillType']);
      this.TrDetFreeDaysOrHrs = this.populateTextTrim(details['TrDetFreeDaysOrHrs']);
      this.TrkStgFreeDaysOrHrs = this.populateTextTrim(details['TrkStgFreeDaysOrHrs']);
      this.billingScheduleCode = this.populateTextTrim(details['abBillingCategory']) ? this.populateTextTrim(details['abBillingCategory']) : '';
      this.billingSchedule = this.populateTextTrim(details['abbillingcategorydesc']) ? this.populateTextTrim(details['abbillingcategorydesc']) : '';
      this.selectedabInvoiceOption = this.populateObject(this.abInvoiceOptionData, 'InvoiceOption', details['abInvoiceOption']);
      //#endregion      

      //#region populate Credit Management tab
      this.selectedCreditController = this.populateObject(this.CreditControllerData, 'EmployeeID', details['CreditController']);
      this.CreditLimit = this.populateTextTrim(details['CreditLimit']);
      this.CreditTerm = this.populateTextTrim(details['CreditTerm']);
      this.selectedCreditType = this.populateObject(this.CreditTypeData, 'Credit Type', details['CreditType']);
      this.CrRating = this.populateTextTrim(details['CrRating']);
      this.shipcon_overpay = this.populateTextTrim(details['cu_overpay']);
      this.shipcon_crdlmt = this.populateTextTrim(details['cu_crdlmt']);
      this.CurrentOutStanding = this.populateTextTrim(details['CurrentOutStanding']);
     
      this.selectedApprovedBy = details['ExtendedCredit'] ? this.populateObject(this.ApprovedByData, 'EmployeeID', details['ExtendedCredit']['ApprovedBy']) : null;
      this.ExtCreditLimit = details['ExtendedCredit'] ? this.populateTextTrim(details['ExtendedCredit']['ExtCreditLimit']) : '';
      this.ExtCreditTerm = details['ExtendedCredit'] ? this.populateTextTrim(details['ExtendedCredit']['ExtCreditTerm']) : '';
      this.ExtCreditType = this.populateObject(this.CreditTypeData, 'Credit Type', details['CreditType']);
      this.ValidFr = details['ExtendedCredit'] ? new Date(details['ExtendedCredit']['ValidFr']) : null;
      this.ValidTo = details['ExtendedCredit'] ? new Date(details['ExtendedCredit']['ValidTo']) : null;
      
      this.AuditExtendedCreditData = details['AuditExtendedCredit'] ? Array.isArray(details['AuditExtendedCredit']) ? details['AuditExtendedCredit'] : [details['AuditExtendedCredit']] : [];
      this.AuditExtendedCreditData.forEach(data => {
        data['ValidFrom'] = data['ValidFrom'] ? this.$dateTime.getDateTime(new Date(data['ValidFrom']), 'dd/MM/yyyy HH:mm') : null;
        data['ValidTo'] = data['ValidTo'] ? this.$dateTime.getDateTime(new Date(data['ValidTo']), 'dd/MM/yyyy HH:mm') : null;
        data['DateUpdate'] = data['DateUpdate'] ? this.$dateTime.getDateTime(new Date(data['DateUpdate']), 'dd/MM/yyyy HH:mm') : null;
      });
      this.AuditExtendedCreditData = this.AuditExtendedCreditData;      
      // #endregion

      //#region populate Sales & Service Team tab
      this.SalesServiceData = details['SalesService'] ? Array.isArray(details['SalesService']) ? details['SalesService'] : [details['SalesService']] : [];
      this.SalesServiceData.forEach(data => {
        data['DateUpdated'] = data['DateUpdated'] ? this.$dateTime.getDateTime(new Date(data['DateUpdated']), 'dd/MM/yyyy HH:mm') : null;
      });
      this.SalesServiceData = this.SalesServiceData;   
      this.SalesServiceData.forEach(s => this.originalSalesService.push(s));  
      //#endregion

      //#region populate Attachments tab
      this.attachmentsData = attachments;
      this.attachmentsData.forEach(a => this.originalAttachments.push(a));
      //#endregion
      
      //#region populate GST/SST/eInvoice tab
      // this.gstData['comRegNo'] = this.populateTextTrim(details['Cus_RegNo']);
      this.gstData['comRegNo'] = details['GST'] ? this.populateTextTrim(details['GST']?.['GST2CoRegNo']) : '';
      this.gstData['dateVerified'] = details['GST']?.['GST2DateStatusVerified'] ? new Date(details['GST']['GST2DateStatusVerified']) : '';
      this.gstData['licenseNo'] = details['GST'] ? this.populateTextTrim(details['GST']['GST2LicenseNo']) : '';
      this.gstData['rmcdApprovalNo'] = details['GST'] ? this.populateTextTrim(details['GST']['GST2RMCDApprovalNo']) : '';
      this.gstData['selectedTaxCode'] = details['GST'] ? this.populateObject(this.gstData['taxCodeItems'], 'Tax Code', details['GST']['GST2TaxCode']) : '';
      this.SSTLicenseNo = details['GST'] ? this.populateTextTrim(details['GST']['GSTLicenseNo']) : '';
      this.eInvoiceTIN = details['GST'] ? this.populateTextTrim(details['GST']['TIN']) : '';
      this.custType = details['CustType'];
      //#endregion

      this.$fullscreenLoading();
    },
    clearTabFields: function() {
      this.viewMode = false;

      this.currentTab = 0;

      this.shipConCode = '';
      this.shipConCodeError = '';
      this.isActive = false;

      this.lastUpdate = '';

      //#region General Details data
      this.selectedShipConCategory = null;
      this.categoryError = '';
      this.shipcon_name = '';
      this.nameError = '';
      this.shipcon_sname = '';
      this.snameError = '';
      this.selectedStatus = null;
      this.statusError = '';
      this.StatusValidFr = null;
      this.showStatusHistory = false;
      this.statusHistoryData = [];
      this.ShipCon_RegNo = '';
      this.regNoError = '';
      this.Subsidiary = '';
      this.subsidiaryError = '';
      this.addressData['addressLine1'] = '';
      this.addressData['addressLine2'] = '';
      this.addressData['addressLine3'] = '';
      this.addressData['addressLine4'] = '';
      this.addressData['postcode'] = '';
      this.addressData['city'] = '';
      this.addressData['state'] = '';
      this.addressData['country'] = '';
      this.addressErrors['addressLine1'] = '';
      this.addressErrors['addressLine2'] = '';
      this.addressErrors['addressLine3'] = '';
      this.addressErrors['addressLine4'] = '';
      this.addressErrors['city'] = '';
      this.shipcon_phone = '';
      this.phoneError = '';
      this.shipcon_fax = '';
      this.faxError = '';
      this.shipcon_email = '';
      this.emailError = '';
      this.selectedBranch = null;
      this.selectedSMKFACode = null;
      //#endregion

      //#region Contact Details data
      this.contactPerson = '';
      this.contactPersonError = '';
      this.contacts = [];
      this.originalContact = [];
      //#endregion

      //#region Billing Info data
      this.custType = "1";
      this.billingScheduleShow = false;
      this.selectedCustCode = null;
      this.custCodeError = '';
      this.selectedDefaultPayType = null;
      this.BillingTerm = '0';
      this.billingTermError = '';
      this.selectedBillingType = null;
      this.selectedBillingFmt = null;
      this.selectedDefaultCur = null;
      this.selectedCu_GLAcc = this.populateObject(this.Cu_GLAccData, 'Acc No', this.DefaultGLAccData['debtorctrlacc']);
      this.glAccCodeError = '';
      this.CDAPrintPrice = false;
      this.selectedInternalCust = null;
      this.selectedDepotStorageBillType = this.populateObject(this.DepotStorageBillTypeData, 'DepotStorageBillType', "0");
      this.TrDetFreeDaysOrHrs = '0';
      this.TrDetFreeDaysOrHrsError = '';
      this.TrkStgFreeDaysOrHrs = '0';
      this.TrkStgFreeDaysOrHrsError = '';
      this.billingSchedule = 'None';
      this.selectedabInvoiceOption = this.populateObject(this.abInvoiceOptionData, 'InvoiceOption', "0");

      this.clearBillingDetails();
      //#endregion

      //#region Credit Management data
      this.selectedCreditController = null;
      this.CreditLimit = '';
      this.creditLimitError = '';
      this.CreditTerm = '';
      this.creditTermError = '';
      this.selectedCreditType = null;
      this.CrRating = '';
      this.crRatingError = '';
      this.shipcon_overpay = '';
      this.shipcon_overpayError = '';
      this.shipcon_crdlmt = '';
      this.shipcon_crdlmtError = '';
      this.CurrentOutStanding = '';
      this.selectedApprovedBy = null;
      this.ExtCreditLimit = '';
      this.extCreditLimitError = '';
      this.ExtCreditTerm = '';
      this.extCreditTermError = '';
      this.validFrError = '';
      this.validToError = '';
      this.ExtCreditType = '';
      this.ValidFr = null;
      this.ValidTo = null;
      this.AuditExtendedCreditData = [];
      //#endregion

      //#region Sales & Service Team data
      this.showShipConSalesDetails = false;
      this.SalesServiceData = [];
      this.originalSalesService = [];
      this.selectedTeams = [];

      this.clearSalesServiceTeamsField();
      //#endregion
      
      //#region Attachments data
      this.attachmentsData = [];
      this.originalAttachments = [];
      //#endregion

      //#region GST/SST/eInvoice data
      this.gstData['comRegNo'] = '';
      this.gstData['dateVerified'] = null;
      this.gstData['licenseNo'] = '';
      this.gstData['licenseNoError'] = '';
      this.gstData['rmcdApprovalNo'] = '';
      this.gstData['rmcdApprovalNoError'] = '';
      this.gstData['selectedTaxCode'] = null;
      this.SSTLicenseNo = '';
      this.eInvoiceTIN ='';
      //#endregion
    },
    clearEntryMessages: function() {
      this.entryRequired = [];
      this.entrySuccess = [];
      this.entryMessages = [];
      this.entryError = [];
    },
    entryRequiredClicked: function(item) {
      let errorTabs = this.errorMapping.find(e => e['key'] == item);
      
      if (this.currentTab != errorTabs['tab'] && errorTabs['tab'] >= 0) {
        this.currentTab = errorTabs['tab'];
      }

      this.$nextTick(() => {
        switch (errorTabs['key']) {       
          case "shipcon_addressline1":
            this.$refs["addressForm"].setFocus('address1');
            break;

          case "shipcon_addressline2":
            this.$refs["addressForm"].setFocus('address2');
            break;

          case "shipcon_addressline3":
            this.$refs["addressForm"].setFocus('address3');
            break;

          case "shipcon_addressline4":
            this.$refs["addressForm"].setFocus('address4');
            break;

          case "shipcon_city":
            this.$refs["addressForm"].setFocus('city');
            break;

          case "shipcon_contact":
            this.$refs["contactTab"].focusContactPersonInput();
            break;

          case "gst_licenseno":
            this.$refs["gstTab"].focusGSTInput('licenseno');
            break;

          case "gst_rmcdapprovalno":
            this.$refs["gstTab"].focusGSTInput('rmcdapprovalno');
            break;

          default:
            this.$refs[item].setFocus();
            break;
        }
      });
    },
    populateObject: function(data, key, compare) { // To populate object into dropdown or input query
      try {
        return data.find(d => d[key].trim() == (compare ? compare.trim() :''));
      } catch (error) {
        return null;
      }
    },
    populateTextTrim: function(text) {  // To populate text with trim
      return text ? text.trim() : '';
    },
    checkFields: function() {
      this.clearEntryMessages();

      if (!this.shipConCode) {
        this.shipConCodeError = 'Shipper/Consignee Code is required!';
        this.entryRequired.push({ key: 'shipConCode', value: 'Shipper/Consignee Code is required!' });
      }
      else {
        if (this.shipConCode.length > 10) {
          this.shipConCodeError = 'Shipper/Consignee Code cannot exceed 10 characters!';
          this.entryRequired.push({ key: 'shipConCode', value: 'Shipper/Consignee Code cannot exceed 10 characters!' });
        }
      }
      if (!this.selectedShipConCategory) {
        this.categoryError = 'Shipper/Consignee Category is required!';
        this.entryRequired.push({ key: 'shipcon_category', value: 'Shipper/Consignee Category is required!' });
      }
      if (!this.shipcon_name) {
        this.nameError = 'Shipper/Consignee Name is required!';
        this.entryRequired.push({ key: 'shipcon_name', value: 'Shipper/Consignee Name is required!' });
      }
      else {
        if (this.shipcon_name.length > 100) {
          this.nameError = 'Shipper/Consignee cannot exceed 100 characters!';
          this.entryRequired.push({ key: 'shipcon_name', value: 'Shipper/Consignee cannot exceed 100 characters!' });
        }
      }
      if (!this.shipcon_sname) {
        this.snameError = 'Shipper/Consignee Short Name is required!';
        this.entryRequired.push({ key: 'shipcon_sname', value: 'Shipper/Consignee Short Name is required!' });
      }
      else {
        if (this.shipcon_sname.length > 20) {
          this.snameError = 'Shipper/Consignee Short Name cannot exceed 20 characters!';
          this.entryRequired.push({ key: 'shipcon_sname', value: 'Shipper/Consignee Short Name cannot exceed 20 characters!' });
        }
      }
      if (!this.selectedStatus) {
        this.statusError = 'Shipper/Consignee Status is required!';
        this.entryRequired.push({ key: 'shipcon_status', value: 'Shipper/Consignee Status is required!' });
      }
      if (this.ShipCon_RegNo.length > 20) {
        this.regNoError = 'Comp Reg. No cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'shipcon_regno', value: 'Comp Reg. No cannot exceed 20 characters!' });
      }
      if (this.Subsidiary.length > 10) {
        this.subsidiaryError = 'Subsidiary of cannot exceed 10 characters!';
        this.entryRequired.push({ key: 'shipcon_subsidiary', value: 'Subsidiary of cannot exceed 10 characters!' });
      }
      if (this.addressData.addressLine1.length > 40) {
        this.addressErrors.addressLine1 = 'Address Line 1 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'shipcon_addressline1', value: 'Address Line 1 cannot exceed 40 characters!' });
      }
      if (this.addressData.addressLine2.length > 40) {
        this.addressErrors.addressLine2 = 'Address Line 2 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'shipcon_addressline2', value: 'Address Line 2 cannot exceed 40 characters!' });
      }
      if (this.addressData.addressLine3.length > 40) {
        this.addressErrors.addressLine3 = 'Address Line 3 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'shipcon_addressline3', value: 'Address Line 3 cannot exceed 40 characters!' });
      }
      if (this.addressData.addressLine4.length > 40) {
        this.addressErrors.addressLine4 = 'Address Line 4 cannot exceed 40 characters!';
        this.entryRequired.push({ key: 'shipcon_addressline4', value: 'Address Line 4 cannot exceed 40 characters!' });
      }
      if (this.addressData.city.length > 30) {
        this.addressErrors.city = 'City cannot exceed 30 characters!';
        this.entryRequired.push({ key: 'shipcon_city', value: 'City cannot exceed 30 characters!' });
      }
      if (this.shipcon_phone.length > 20) {
        this.phoneError = 'Phone no cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'shipcon_phone', value: 'Phone no cannot exceed 20 characters!' });
      }
      if (this.shipcon_fax.length > 20) {
        this.faxError = 'Fax no cannot exceed 20 characters!';
        this.entryRequired.push({ key: 'shipcon_fax', value: 'Fax no cannot exceed 20 characters!' });
      }
      if (this.shipcon_email.length > 100) {
        this.emailError = 'Email cannot exceed 100 characters!';
        this.entryRequired.push({ key: 'shipcon_email', value: 'Email cannot exceed 100 characters!' });
      }

      if (this.contactPerson.length > 100) {
        this.contactPersonError = 'Contact Person cannot exceed 100 characters!';
        this.entryRequired.push({ key: 'shipcon_contact', value: 'Contact Person cannot exceed 100 characters!' });
      }

      // if (!this.selectedCustCode) {
      //   this.custCodeError = 'Billing Customer Code is required!';
      //   this.entryRequired.push({ key: 'shipcon_billcustcode', value: 'Billing Customer Code is required!' });
      // }
      if (+this.BillingTerm > 2000000000) {
        this.billingTermError = 'Billing term value too big!';
        this.entryRequired.push({ key: 'shipcon_billingterm', value: 'Billing term value too big!' });
      }
      // if (!this.selectedCu_GLAcc) {
      //   this.glAccCodeError = 'Billing GL Acc Code is required!';
      //   this.entryRequired.push({ key: 'shipcon_glacccode', value: 'Billing GL Acc Code is required!' });
      // }
      if (+this.TrDetFreeDaysOrHrs > 2000000000) {
        this.TrDetFreeDaysOrHrsError = 'Trailer Detention value too big!';
        this.entryRequired.push({ key: 'shipcon_trailerdetention', value: 'Trailer Detention value too big!' });
      }
      if (+this.TrkStgFreeDaysOrHrs > 2000000000) {
        this.TrkStgFreeDaysOrHrsError = 'Trailer Staging value too big!';
        this.entryRequired.push({ key: 'shipcon_trailerstaging', value: 'Trailer Staging value too big!' });
      }

      if (!this.CreditLimit.match(/^\d*\.?\d*$/g) && this.CreditLimit) {
        this.creditLimitError = 'Credit Limit format error!';
        this.entryRequired.push({ key: 'shipcon_creditlimit', value: 'Credit Limit format error! Please make sure input is in money format.' });
      }
      else {
        if (+this.CreditLimit > 900000000000000) {
          this.creditLimitError = 'Credit Limit value too big!';
          this.entryRequired.push({ key: 'shipcon_creditlimit', value: 'Credit Limit value too big!' });
        } 
      }
      if (+this.CreditTerm > 2000000000) {
        this.creditTermError = 'Credit Term value too big!';
        this.entryRequired.push({ key: 'shipcon_creditterm', value: 'Credit Term value too big!' });
      } 
      if (+this.CrRating > 2000000000) {
        this.crRatingError = 'Credit Rating value too big!';
        this.entryRequired.push({ key: 'shipcon_creditrating', value: 'Credit Rating value too big!' });
      } 
      if (!this.shipcon_overpay.match(/^\d*\.?\d*$/g) && this.shipcon_overpay) {
        this.shipcon_overpayError = 'Overdraft Amount format error!';
        this.entryRequired.push({ key: 'shipcon_overdraft', value: 'Overdraft Amountformat error! Please make sure input is in money format.' });
      }
      else {
        if (+this.shipcon_overpay > 900000000000000) {
          this.shipcon_overpayError = 'Overdraft Amount value too big!';
          this.entryRequired.push({ key: 'shipcon_overdraft', value: 'Overdraft Amount value too big!' });
        } 
      }
      if (!this.shipcon_crdlmt.match(/^\d*\.?\d*$/g) && this.shipcon_crdlmt) {
        this.shipcon_crdlmtError = 'Cash Float Amount format error!';
        this.entryRequired.push({ key: 'shipcon_cashfloat', value: 'Cash Float Amount format error! Please make sure input is in money format.' });
      }
      else {
        if (+this.shipcon_crdlmt > 999999.99) {
          this.shipcon_crdlmtError = 'Cash Float Amount too big!';
          this.entryRequired.push({ key: 'shipcon_cashfloat', value: 'Cash Float Amount value too big!' });
        } 
      }
      if (!this.ExtCreditLimit.match(/^\d*\.?\d*$/g) && this.ExtCreditLimit) {
        this.extCreditLimitError = 'Extended Credit Limit format error!';
        this.entryRequired.push({ key: 'shipcon_extcreditlimit', value: 'Extended Credit Limit format error! Please make sure input is in money format.' });
      }
      else {
        if (+this.ExtCreditLimit > 900000000000000) {
          this.extCreditLimitError = 'Extended Credit Limit value too big!';
          this.entryRequired.push({ key: 'shipcon_extcreditlimit', value: 'Extended Credit Limit too big!' });
        } 
      }
      if (+this.ExtCreditTerm > 2000000000) {
        this.extCreditTermError = 'Extended Credit Term value too big!';
        this.entryRequired.push({ key: 'shipcon_extcreditterm', value: 'Extended Credit Term value too big!' });
      } 
      if (this.ValidFr && this.ValidTo && (this.ValidFr > this.ValidTo)) {
        this.validFrError = 'Valid From cannot be later than Valid To';
        this.validToError = 'Valid To cannot be earlier than Valid From';
        this.entryRequired.push({ key: 'shipcon_validfrom', value: 'Valid From cannot be later than Valid To' });
        this.entryRequired.push({ key: 'shipcon_validto', value: 'Valid To cannot be earlier than Valid From' });
      }

      if (this.gstData.licenseNo.length > 50) {
        this.gstData.licenseNoError = 'License No cannot exceed 50 characters!';
        this.entryRequired.push({ key: 'gst_licenseno', value: 'License No cannot exceed 50 characters!' });
      }
      if (this.gstData.rmcdApprovalNo.length > 25) {
        this.gstData.rmcdApprovalNoError = 'RMCD Approval No cannot exceed 25 characters!';
        this.entryRequired.push({ key: 'gst_rmcdapprovalno', value: 'RMCD Approval No cannot exceed 25 characters!' });
      }
      if (this.SSTLicenseNo.length > 50 ){
        this.SSTLicenseNoError = 'SST License No cannot exceed 50 characters!';
        this.entryRequired.push({key: 'SSTLicenseNo', value: 'SST License No cannot exceed 50 characters!'});
      }
      if (this.eInvoiceTIN.length > 13 ){
        this.eInvoiceTINError = 'Tax Identification No (TIN) cannot exceed 13 characters!';
        this.entryRequired.push({key: 'eInvoiceTIN', value: 'Tax Identification No (TIN) cannot exceed 13 characters!'})
      }

      return this.entryRequired.length > 0;
    },
    saveClicked: async function() {
      let isNotValid = this.checkFields();

      if (!isNotValid) {
        let action = this.popupEntryTitle[0];

        let contactToSend = this.contacts.filter(c => c['contactaction']);
        let salesServiceToSend = this.SalesServiceData.filter(s => s['SalesAction']);
        let attachmentsToSend = this.attachmentsData.filter(a => a['attachmentaction']);

        //#region For deleted contacts
        let ids = this.contacts.map(ct => ct['ID']);
        let deleted = this.originalContact.filter(c => !ids.includes(c['ID']) );
        deleted.forEach(d => d['contactaction'] = 'D');
        contactToSend = contactToSend.concat(deleted);
        //#endregion

        //#region For deleted attachments
        let attIds = this.attachmentsData.map(a => a['ID']);
        let attDeleted = this.originalAttachments.filter(o => !attIds.includes(o['ID']));
        attDeleted.forEach(ad => ad['attachmentaction'] = 'D');
        attachmentsToSend = attachmentsToSend.concat(attDeleted);
        //#endregion

        //#region For deleted sales service
        let salesServiceJobTypes = this.SalesServiceData.map(s => s['JobType']);
        let salesServiceSystems = this.SalesServiceData.map(s => s['System']);
        let salesServiceDeleted = this.originalSalesService.filter(o => !(salesServiceJobTypes.includes(o['JobType']) && salesServiceSystems.includes(o['System'])));
        salesServiceDeleted.forEach(sd => sd['SalesAction'] = 'D');
        salesServiceToSend = salesServiceToSend.concat(salesServiceDeleted);
        //#endregion

        contactToSend.forEach(c => { // To make sure that if action is E, ID cannot be empty
          if (c['contactaction'] == 'E' && !c['ID']) {
            c['contactaction'] = 'N';
          }
        });
        
        salesServiceToSend.forEach(s => { // To make sure that if action is E, UserID cannot be empty
          if (s['SalesAction'] == 'E' && !s['UserID']) {
            s['SalesAction'] = 'N';
          }
        });

        if (Number.isNaN(this.gstData['dateVerified'])) {
          console.log('date NaN');
        }
        
        let dataToPost = {
          action: action,
          cu_number: this.shipConCode,
          LastUpdate: this.lastUpdate,

          //#region from General Details tab
          CustType: this.custType,
          cu_name: this.shipcon_name,
          cu_sname: this.shipcon_sname,
          Cus_RegNo: this.ShipCon_RegNo,
          Subsidiary: this.Subsidiary,
          StatusValidFr: this.StatusValidFr ? this.$dateTime.getDateTime(this.StatusValidFr, 'yyyy-MM-dd HH:mm') : '',
          cu_addr1: this.addressData['addressLine1'],
          cu_addr2: this.addressData['addressLine2'],
          cu_addr3: this.addressData['addressLine3'],
          cu_addr4: this.addressData['addressLine4'],
          Postcode: this.addressData['postcode'],
          City: this.addressData['city'],
          State: this.addressData['state'],
          Country: this.addressData['country'],
          cu_phone: this.shipcon_phone,
          cu_fax: this.shipcon_fax,
          cu_email: this.shipcon_email,
          CustCategory: this.selectedShipConCategory ? this.selectedShipConCategory['Customer Category'] : '',
          Status: this.selectedStatus ? this.selectedStatus['Customer Status'] : '',
          BrCode: this.selectedBranch ? this.selectedBranch['Branch Code'] : '',
          smkfacode: this.selectedSMKFACode ? this.selectedSMKFACode['FA Code'] :  '',  
          //#endregion

          //#region from Contact Details tab
          cu_contact: this.contactPerson,
          Contact: contactToSend,
          //#endregion

          //#region from Billing Info tab
          cu_BillTo: this.selectedCustCode ? this.selectedCustCode['Customer Code'] : '',
          DefaultPayType: this.selectedDefaultPayType ? this.selectedDefaultPayType['Payment Type'] : '',
          BillingTerm: this.BillingTerm,
          BillingType: this.selectedBillingType ? this.selectedBillingType['BillType'] : '',
          BillingFmt: this.selectedBillingFmt ? this.selectedBillingFmt['Billing Fmt'] : '',
          DefaultCur: this.selectedDefaultCur ? this.selectedDefaultCur['Currency Code'] : '',
          Cu_GLAcc: this.selectedCu_GLAcc ? this.selectedCu_GLAcc['Acc No'] : '',
          CDAPrintPrice: this.CDAPrintPrice ? '1' : '0',
          InternalCust: this.selectedInternalCust ? this.selectedInternalCust['InternalCustType'] : '',
          DepotStorageBillType: this.selectedDepotStorageBillType ? this.selectedDepotStorageBillType['DepotStorageBillType'] : '',
          TrkStgFreeDaysOrHrs: this.TrkStgFreeDaysOrHrs,
          TrDetFreeDaysOrHrs: this.TrDetFreeDaysOrHrs,
          abBillingCategory: this.billingScheduleCode,
          abInvoiceOption: this.selectedabInvoiceOption ? this.selectedabInvoiceOption['InvoiceOption'] : '',
          //#endregion

          //#region from Credit Management tab
          CreditController: this.selectedCreditController ? this.selectedCreditController['EmployeeID'] : '',
          CreditLimit: this.CreditLimit,
          CreditTerm: this.CreditTerm,
          CreditType: this.selectedCreditType ? this.selectedCreditType['Credit Type'] : '',
          CrRating: this.CrRating,
          cu_overpay: this.shipcon_overpay,
          cu_crdlmt: this.shipcon_crdlmt ? this.shipcon_crdlmt : 0,
          CurrentOutStanding: this.CurrentOutStanding,
          ExtApprovedBy: this.selectedApprovedBy ? this.selectedApprovedBy['EmployeeID'] : '',
          ExtCreditLimit: this.ExtCreditLimit,
          ExtCreditTerm: this.ExtCreditTerm,
          ExtCreditType: this.selectedCreditType ? this.selectedCreditType['Credit Type'] : '', // should always be the same as Credit Type
          ExtValidFr: this.ValidFr ? this.$dateTime.getDateTime(this.ValidFr, 'yyyy-MM-dd HH:mm') : '',
          ExtValidTo: this.ValidTo ? this.$dateTime.getDateTime(this.ValidTo, 'yyyy-MM-dd HH:mm') : '',
          //#endregion
          
          //#region from Sales & Service Team tab
          SalesService: salesServiceToSend,
          //#endregion

          //#region from Attachments tab
          Attachment: attachmentsToSend,
          //#endregion

          //#region from GST/SST/eInvoice tab
          GST: {
            GST2CoRegNo: this.gstData['comRegNo'],
            GST2DateStatusVerified: this.gstData['dateVerified'] && Number.isNaN(this.gstData['dateVerified']) == false ? this.$dateTime.getDateTime(this.gstData['dateVerified'], 'yyyy-MM-dd HH:mm') : '',
            GST2LicenseNo: this.gstData['licenseNo'],
            GST2RMCDApprovalNo: this.gstData['rmcdApprovalNo'],
            GST2TaxCode: this.gstData['selectedTaxCode'] ? this.gstData['selectedTaxCode']['Tax Code'] : '',
            GSTLicenseNo: this.SSTLicenseNo,
            TIN: this.eInvoiceTIN,
          }
          //#endregion
        };

        this.$fullscreenLoading('Saving Shipper/Consignee');
        let result = await this.$apiCallV2('/ShipperConsignee/SaveShipperConsignee', dataToPost);

        if (result[0]['Results'] == 0) { // Save successful
          if (action == 'N') {
            this.entrySuccess.push(`Successfully created shipper/consignee ${result[0]['cu_number']}`);
          } else {
            this.entrySuccess.push(`Successfully edited shipper/consignee ${result[0]['cu_number']}`);
          }

          this.selectedShipCon = [];
          this.shipConList = [];
          this.viewMode = true;
          this.popupEntryTitle = "View Shipper/Consignee";
          this.currentTab = 0;
          this.$nextTick(async () => await this.getShippersConsignees2());
        } else { // Save error
          if (action == 'N') {
            this.entryError.push(`There was an error creating your new shipper/consignee: ${result[0]['ErrMsg']}`);
          } else {
            this.entryError.push(`There was an error editting shipper/consignee: ${result[0]['ErrMsg']}`);
          }
        }        
      }
    },

    //#region Billing Info methods
    changeBillingSchedule: function() {
      this.billingScheduleShow = true;

      let selected = this.billingSchedule.split(' - ')[0].toLowerCase();
      this.scheduleSelectionNone = false;
      
      let days = this.billingScheduleCode ? this.billingScheduleCode.substring(1) : '';

      if (selected == 'none') { // For none
        this.scheduleSelectionNone = true;
      } else if (selected == 'daily') { // For daily
        this.scheduleSelectionDaily = true;
      } else if (selected == 'weekly') { // For weekly
        let index = 0, daysIndex = [];
        while (index < days.length) {
          daysIndex.push(Number(days.substring(index, index + 2)) - 1);
          index += 2;
        }

        let dayKeys = Object.keys(this.dayChecked);
        daysIndex.forEach(d => {
          this.dayChecked[dayKeys[d]] = true
        });
        this.weeklyCheckbox();
        this.scheduleSelectionWeekly = true;
      } else if (selected == 'monthly') { // For monthly
        let day1 = days.substring(0, 2), day2 = days.substring(2, 4);
        this.selectedDay1 = this.daysData.find(d => d['CodeValue'] == day1);
        this.selectedDay2 = this.daysData.find(d => d['CodeValue'] == day2);
        this.scheduleSelectionMonthly = true;
      } else if (selected == 'quarterly') { // For quarterly
        let quart = days.substring(0, 2), quartDay = days.substring(2, 4);
        this.selectedQuarter = this.quarterData.find(q => q['CodeValue'] == quart);
        this.selectedQuarterDay = this.daysData.find(d => d['CodeValue'] == quartDay);
        this.scheduleSelectionQuarterly = true;
      }
    },
    saveBillingSchedule: function() {
      let quarterMonths = [
        [ 'Jan', 'Feb', 'Mar' ],
        [ 'Apr', 'May', 'Jun' ],
        [ 'Jul', 'Aug', 'Sep' ],
        [ 'Oct', 'Nov', 'Dec' ]
      ];

      if (this.scheduleSelectionNone || (!this.scheduleSelectionNone && !this.scheduleSelectionDaily && !this.scheduleSelectionWeekly && !this.scheduleSelectionMonthly && !this.scheduleSelectionQuarterly)) {
        this.billingSchedule = 'None';
        this.billingScheduleCode = '';
      }

      if (this.scheduleSelectionDaily) { // For daily
        this.billingSchedule = 'Daily';
        this.billingScheduleCode = 'D';
      } else if (this.scheduleSelectionWeekly) { // For weekly
        if (!this.daysSelected) {
          this.daysSelectedError = 'Please choose at least 1 day';
          return;
        }
        this.billingSchedule = `Weekly - ${this.daysSelected}`;

        let days = this.daysSelected.split(' ');
        let indexes = '';
        days.forEach(d => indexes += `0${Object.keys(this.dayChecked).indexOf(d) + 1}`);

        this.billingScheduleCode = `W${indexes}`;
      } else if (this.scheduleSelectionMonthly) { // For monthly
        let error = false;
        if (!this.selectedDay1) {
          this.day1Error = 'Please select day 1';
          error = true;
        }
        if (!this.selectedDay2) {
          this.day2Error = 'Please select day 2';
          error = true;
        }

        if (error) { return }
        else {
          this.billingSchedule = `Monthly - Every ${this.selectedDay1['CodeValue']} and ${this.selectedDay2['CodeValue']} of the month`;
          this.billingScheduleCode = `M${this.selectedDay1['CodeValue']}${this.selectedDay2['CodeValue']}`;
        }
      } else if (this.scheduleSelectionQuarterly) { // For quarterly
        let error = false;
        if (!this.selectedQuarter) {
          this.quarterError = 'Please select the months in the quarter';
          error = true;
        }
        if (!this.selectedQuarterDay) {
          this.quarterDayError = 'Please select day of the month';
          error = true;
        }

        if (error) { return }
        else {
          let quarter = Number(this.selectedQuarter['CodeValue']);
          let months = quarterMonths.map(q => q[quarter - 1]).join(', ');
          this.billingSchedule = `Quarterly - Every month #${quarter} of the quarter (${months}) on day ${Number(this.selectedQuarterDay['CodeValue'])}`;
          this.billingScheduleCode = `Q${this.selectedQuarter['CodeValue']}${this.selectedQuarterDay['CodeValue']}`;
        }
      }

      this.billingScheduleShow = false;
    },
    scheduleSelectionChecked: function(item) {
      let isTrue = this[item];
      this.scheduleSelectionNone = false;
      this.scheduleSelectionDaily = false;
      this.scheduleSelectionWeekly = false;
      this.scheduleSelectionMonthly = false;
      this.scheduleSelectionQuarterly = false;

      if (isTrue) {
        this[item] = true;
      }
    },
    weeklyCheckbox: function() {
      this.daysSelectedError = '';
      this.daysSelected = Object.entries(this.dayChecked).map(([k, v]) => { if (v) return k }).filter(k => k).join(' ');
    },
    clearBillingDetails: function() {
      this.scheduleSelectionNone = true;
      this.scheduleSelectionDaily = false;
      this.scheduleSelectionWeekly = false;
      this.dayChecked['Monday'] = false;
      this.dayChecked['Tuesday'] = false;
      this.dayChecked['Wednesday'] = false;
      this.dayChecked['Thursday'] = false;
      this.dayChecked['Friday'] = false;
      this.dayChecked['Saturday'] = false;
      this.dayChecked['Sunday'] = false;
      this.daysSelected = '';
      this.daysSelectedError = '';
      this.scheduleSelectionMonthly = false;
      this.scheduleSelectionQuarterly = false;
      this.selectedDay1 = null;
      this.selectedDay2 = null;
      this.day1Error = '';
      this.day2Error = '';
      this.selectedQuarter = null;
      this.quarterError = '';
      this.selectedQuarterDay = null;
      this.quarterDayError = '';
    },
    //#endregion

    //#region Credit Management methods
    enableExtCredFields: function() {
      this.extCreditEnabled = true;
      this.tempSelectedApprovedBy = this.selectedApprovedBy;
      this.tempExtCreditLimit = this.ExtCreditLimit;
      this.tempExtCreditTerm = this.ExtCreditTerm;
      this.tempExtCreditType = this.ExtCreditType;
      this.tempValidFr = this.ValidFr;
      this.tempValidTo = this.ValidTo;
    },
    applyExtCredFields: function() {
      this.extCreditEnabled = false;
    },
    cancelExtCredFields: function() {
      this.extCreditEnabled = false;
      this.selectedApprovedBy = this.tempSelectedApprovedBy;
      this.ExtCreditLimit = this.tempExtCreditLimit;
      this.ExtCreditTerm = this.tempExtCreditTerm;
      this.ExtCreditType = this.tempExtCreditType;
      this.ValidFr = this.tempValidFr;
      this.ValidTo = this.tempValidTo;
    },
    //#endregion

    //#region Sales & Service Team methods
    deleteShipConSales: function() {
      if (this.selectedTeams.length == 0) {
        this.$showAlert('error', 'No Team selected', 'Please select at least 1 team to delete');
      } else {
        let temp = this.SalesServiceData;
        this.SalesServiceData = [];

        this.selectedTeams.forEach(t => {
          let index = temp.findIndex(s => s['JobType'] === t['JobType'] && s['System'] === t['System']);
          temp.splice(index, 1);
        });

        this.$nextTick(() => {
          this.SalesServiceData = temp;
          this.selectedTeams = [];
        });
      }
    },
    editShipConSales: function(btn, data) {
      if (this.viewMode) return;

        this.editSalesServiceIndex = this.SalesServiceData.findIndex(s => s['JobType'] === data['JobType'] && s['System'] === data['System']);
        this.Default = data['DefaultCust'] == 'Y';
        this.selectedSystem = this.SystemData.find(d => d['System'].toLowerCase().trim() == (data['System'] ? data['System'].toLowerCase().trim() : null));
        this.selectedJobType = this.JobTypeData.find(d => d['JobType'].toLowerCase().trim() == (data['JobType'] ? data['JobType'].toLowerCase().trim() : null));
        this.selectedSalesTeam = this.SalesTeamData.find(d => d['Sales Team Code'].toLowerCase().trim() == (data['SalesTeam_Code'] ? data['SalesTeam_Code'].toLowerCase().trim() : null));
        this.SalesPerson = data['DefaultSalesPerson'];
        this.selectedServiceTeam = this.ServiceTeamData.find(d => d['Service Team Code'].toLowerCase().trim() == (data['ServiceTeam_Code'] ? data['ServiceTeam_Code'].toLowerCase().trim() : null));
        this.ServicePerson = data['DefaultServicePerson'];

        if (btn == 'Set Default') {
          this.Default = true;
          this.saveTeam();
        } else if (btn == 'Edit') {
          this.showShipConSalesDetails = true;
        }
      
      //below is original code
      // if (btn == 'Set Default') {
      //   let temp = this.SalesServiceData;
      //   this.SalesServiceData = [];
      //   let index = temp.findIndex(s => s['JobType'] === data['JobType'] && s['System'] === data['System']);
        
      //   temp.forEach(t => t['DefaultCust'] = '');
      //   temp[index]['DefaultCust'] = 'Y';
    
      //   this.$nextTick(() => {
      //     this.SalesServiceData = temp;
         

      //     this.$nextTick(() => {
      //       this.selectedTeams = [];
      //     })
      //   });
 
      // } else if (btn == 'Edit') {
      //   this.editSalesServiceIndex = this.SalesServiceData.findIndex(s => s['JobType'] === data['JobType'] && s['System'] === data['System']);
      //   this.Default = data['DefaultCust'] == 'Y';
      //   this.selectedSystem = this.SystemData.find(d => d['System'].toLowerCase().trim() == (data['System'] ? data['System'].toLowerCase().trim() : null));
      //   this.selectedJobType = this.JobTypeData.find(d => d['JobType'].toLowerCase().trim() == (data['JobType'] ? data['JobType'].toLowerCase().trim() : null));
      //   this.selectedSalesTeam = this.SalesTeamData.find(d => d['Sales Team Code'].toLowerCase().trim() == (data['SalesTeam_Code'] ? data['SalesTeam_Code'].toLowerCase().trim() : null));
      //   this.SalesPerson = data['DefaultSalesPerson'];
      //   this.selectedServiceTeam = this.ServiceTeamData.find(d => d['Service Team Code'].toLowerCase().trim() == (data['ServiceTeam_Code'] ? data['ServiceTeam_Code'].toLowerCase().trim() : null));
      //   this.ServicePerson = data['DefaultServicePerson'];

      //   this.showShipConSalesDetails = true;
      // }
    },
    checkTeamFields: function() {
      let error = false;
      if (!this.selectedSystem) {
        this.systemError = 'System is required!';
        error = true;
      }
      if (!this.selectedJobType) {
        this.jobTypeError = 'Job Type is required!'
        error = true;
      }
      if (this.SalesPerson.length > 10) {
        this.salesPersonError = 'Sales Person cannot exceed 10 characters!'
        error = true;
      }
      if (this.ServicePerson.length > 10) {
        this.servicePersonError = 'Service Person cannot exceed 10 characters!'
        error = true;
      }
      if (this.selectedSalesTeam && !this.SalesPerson.trim()) {
        this.salesPersonError = 'Please specify Sales Person for selected Sales Team!'
        error = true;
      }
      if (this.selectedServiceTeam && !this.ServicePerson.trim()) {
        this.servicePersonError = 'Please specify Service Person for selected Service Team!'
        error = true;
      }
      return error;
    },
    saveTeam: function() {
      if (this.viewMode) return;
      if (this.checkTeamFields()) return;
      //If the user is editing, and the sale service that is currently being edited has the same system and job type from the old one, then skip these two blocks of check
      if (this.editSalesServiceIndex > -1) {
        if (!(this.selectedSystem['System'] === this.SalesServiceData[this.editSalesServiceIndex].System && this.selectedJobType['JobType'] === this.SalesServiceData[this.editSalesServiceIndex].JobType)) {
          for (const s of this.SalesServiceData) {
            if (this.selectedSystem['System'] === s.System && this.selectedJobType['JobType'] === s.JobType) {
              this.$showAlert('error', 'Cannot Save Sale Service', 'This sale service already exists. Please ensure the System & JobType for each Sale Service is unique.');
              return;
            }
          }
        }
      }
      else {
        for (const s of this.SalesServiceData) {
          if (this.selectedSystem['System'] === s.System && this.selectedJobType['JobType'] === s.JobType) {
            this.$showAlert('error', 'Cannot Save Sale Service', 'This sale service already exists. Please ensure the System & JobType for each Sale Service is unique.');
            return;
          }
        }
      }
      
      let temp = this.SalesServiceData;
      this.SalesServiceData = [];

      let team = {
        'DefaultCust': this.Default ? 'Y' : '',
        'System': this.selectedSystem ? this.selectedSystem['System'] : '',
        'JobType': this.selectedJobType ? this.selectedJobType['JobType'] : '',
        'SalesTeam_Code': this.selectedSalesTeam ? this.selectedSalesTeam['Sales Team Code'] : '',
        'DefaultSalesPerson': this.SalesPerson,
        'ServiceTeam_Code': this.selectedServiceTeam ? this.selectedServiceTeam['Service Team Code'] : '',
        'DefaultServicePerson': this.ServicePerson,
        'SalesAction': this.editSalesServiceIndex > -1 ? 'E' : 'N',
        'UserID': this.editSalesServiceIndex > -1 ? temp[this.editSalesServiceIndex]['UserID'] : null
      };

      if (this.Default) { // Remove all previous default if the current one is default
        temp.forEach(t => t['DefaultCust'] = '');
      }

      this.$nextTick(() => {
        if (this.editSalesServiceIndex > -1) {
          temp.splice(this.editSalesServiceIndex, 1, team);
        } else {
          temp.push(team);
        }
        this.SalesServiceData = temp;

        this.clearSalesServiceTeamsField();
        this.showShipConSalesDetails = false;
        this.selectedTeams = [];
      });
    },
    clearSalesServiceTeamsField: function() {
      this.selectedSystem = null;
      this.systemError = '';
      this.selectedJobType = null;
      this.jobTypeError = '';
      this.selectedSalesTeam = null;
      this.SalesPerson = '';
      this.salesPersonError = '';
      this.selectedServiceTeam = null;
      this.ServicePerson = '';
      this.servicePersonError = '';
      this.Default = false;

      this.editSalesServiceIndex = -1;
    },
    //#endregion

    validateTaxPayerTin: async function() {
      if (!this.eInvoiceTIN.startsWith('EI') && (!this.gstData['comRegNo'] || this.gstData['comRegNo'] == '')) {
        this.$showAlert('error', 'Missing ID Number', 'Please key in New Comp Reg No');
        return;
      }

      this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/LoadingCircle.gif';
      this.validateTINMsg = 'Validating';

      let jsonBody = {
        tin: this.eInvoiceTIN, 
        brn: this.gstData['comRegNo']
      }
      let result = await this.$apiCallV2('/ARInvoice/ValidateTaxpayerTin', jsonBody);
      if (result?.[0]?.['Results'] == 0) {
        this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/Save.png'
        this.validateTINMsg = 'Valid Taxpayer TIN';
      } else {
        this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/Cancel.png';
        this.validateTINMsg = `Invalid Taxpayer TIN (${result?.[0]?.['ErrMsg']})`;
      }
    }
  },
  async mounted() {
    this.$bus.$on("pageSASControlAccess", x => {
      if (x.page == "Shipper/Consignee") {
        x.data.forEach(k => {
          let selectedMenu = this.menus.find(m => m["key"] == k["Control"]);
          if (selectedMenu) {
            selectedMenu[k["Properties"].toLowerCase()] =
              k["PropertiesValue"] == "True";
          }
        });
      }
    });

    const mountedPromises = [];
    let promisesFulfilled = 0;

    // #region All dropdown items
    mountedPromises.push(
      this.getShippersConsignees().then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.getBillingCustomer().then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/CustomerProfile/GetDefaults', { page: 'customer' }).then((result) => {
        this.DefaultGLAccData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    //#region API call General Details tab
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'customercategory' }).then((result) => {
        this.ShipConCategoryData = result.map((item) => {
          return {
            ...item,
            "Customer Category - Description": `${item['Customer Category']} - ${item['Description']}`,
          };
        });
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'customerstatus' }).then((result) => {
        this.StatusData = result.map((item) => {
          return {
            ...item,
            "Customer Status - Description": `${item['Customer Status']} - ${item['Description']}`,
          };
        });
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );
    
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'branch' }).then((result) => {
        this.BrCodeData = result.map((item) => {
          return {
            ...item,
            "Branch Code - Branch Name": `${item['Branch Code']} - ${item['Branch Name']}`,
          };
        });
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/ShipperConsignee/GetSMKFACode').then((result) => {
        this.SMKFACodeData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );
    //#endregion

    //#region API call Billing Info tab
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'paymenttype' }).then((result) => {
        this.DefaultPayTypeData = result.map((item) => {
          return {
            ...item,
            "Payment Type - Description": `${item['Payment Type']} - ${item['Description']}`,
          };
        });
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );
  
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'billingtype' }).then((result) => {
        this.BillingTypeData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'billingformat' }).then((result) => {
        this.BillingFmtData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'currency' }).then((result) => {
        this.DefaultCurData = result.map((item) => {
          return {
            ...item,
            "Currency Code - Description": `${item['Currency Code']} - ${item['Description']}`,
          };
        });
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'glaccount' }).then((result) => {
        this.Cu_GLAccData = result.map((item) => {
          return {
            ...item,
            "Acc No - Description": `${item['Acc No']} - ${item['Description']}`,
          };
        });
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'internalcusttype' }).then((result) => {
        this.InternalCustData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'depotstoragebill' }).then((result) => {
        this.DepotStorageBillTypeData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'invoiceoption' }).then((result) => {
        this.abInvoiceOptionData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );
    //#endregion

    //#region API call Credit Management tab
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'employee' }).then((result) => {
        this.CreditControllerData = result;
        this.ApprovedByData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'credittype' }).then((result) => {
        this.CreditTypeData = result.map((item) => {
          return {
            ...item,
            "Credit Type - Description": `${item['Credit Type']} - ${item['Description']}`,
          };
        });
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );
    //#endregion

    //#region API call Sales & Service Team tab
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'systemsaleservice' }).then((result) => {
        this.SystemData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'jobtype' }).then((result) => {
        this.JobTypeData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'salesteam' }).then((result) => {
        this.SalesTeamData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );
    
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'serviceteam' }).then((result) => {
        this.ServiceTeamData = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );
    //#endregion

    //#region API call GST/SST/eInvoice tab
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'artaxcode' }).then((result) => {
        let artaxcode = result;

        artaxcode.forEach((t) => { 
          t['Tax Code'] = t['Tax Code'] ? t['Tax Code'].trim() : '';
          t['Tax Code Desc'] = t['Tax Code Desc'] ? t['Tax Code Desc'].trim() : '';
          t['Tax Type'] = t['Tax Type'] ? t['Tax Type'].trim() : '';
        });

        this.gstData['taxCodeItems'] = artaxcode.map((item) => {
          return {
            ...item,
            "Tax Code - Tax Code Desc": `${item['Tax Code']} - ${item['Tax Code Desc']}`,
          };
        });
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );
    //#endregion

    //#region API call Address fields
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'postcode' }).then((result) => {
        this.postcodes = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'state' }).then((result) => {
        this.states = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'country' }).then((result) => {
        this.countries = result;
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      })
    );

    // this.addressData['postcodeItems'] = this.postcodes;
    // this.addressData['stateItems'] = this.states;
    // this.addressData['countryItems'] = this.countries;
    //#endregion

    Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
      this.menus = this.menus.map((menu) => ({
        ...menu,
        enabled: true,
      }));
    });

    for (let i = 0; i < 31; i++) {
      this.daysData.push({ CodeValue: (i + 1) < 10 ? `0${i + 1}` : `${i + 1}` });
      if (i < 3) {
        this.quarterData.push({ CodeValue: (i + 1) < 10 ? `0${i + 1}` : `${i + 1}` })
      }
    }

    if (this.$route.query['new']) {
      this.menuClicked({ title: 'New Shipper/Consignee' });
    }
  },
  watch: {
    billingScheduleShow: function(val) {
      if (!val) {
        this.clearBillingDetails();
      }
    },
    showShipConSalesDetails: function(val) {
      if (!val) {
        this.clearSalesServiceTeamsField();
      }
    },

    popupEntryShow: async function(val) {
      if (!val && this.$route.query['new'] && !this.viewMode) { // When the cancel is click but is not saved (for query new=1)
        let closeWindow = await this.$showAlert('warning', 'Cancelling Shipper/Consignee Creation', `You have not created an Shipper/Consignee profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`, [
          { "text": "Continue Creating" },
          { "text": "Cancel Creating", "color": "red", "textColor": "white" }
        ]);

        if (closeWindow == 'Cancel Creating') { // If user choose to cancel the creating process, it will close the tab
          window.close();
        } else {
          this.popupEntryShow = true;
        }
      } else if (!val && this.$route.query['new'] && this.viewMode) {
        window.close();
      }
    },
    eInvoiceTIN: function() {
      this.validateTINIcon = '';
    },
    'gstData.comRegNo': function() {
      this.validateTINIcon = '';
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.shipcons-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;

  > .right-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }
}

.shipcon-code {
  display: flex;

  > :last-child {
    margin-left: 5px;
  }
}

.rowBox {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: 0.3s;

  > .shortInput {
    width: 30%;
    margin: 3px 10px 0 0;
  }
}

.scheduleDetails {
  width: 40%;

  > .buttonBox {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    padding: 10px 0 0 0;
  }

  > .scheduleBox {
    width: 100%;
    min-height: 20px;
    padding: 10px 5px 5px 5px;
    margin: 12px 0 0 0;
    position: relative;
    border: solid 1px gray;
    border-radius: 3px;

    > .scheduleTitle {
      padding: 0 5px 0 5px;
      position: absolute;
      top: -10px;
      left: 10px;
      background-color: white;
      color: gray;
    }

    > .weeklyBox {
      width: 100%;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    > .alertBox {
      width: 100%;
      height: auto;
      padding: 8px 10px 5px 10px;
      margin: 10px 0 0 0;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: #ff0000;
      border: solid 1px #ff000088;
      border-radius: 3px;

      > .alertTitle {
        padding: 0 5px 0 5px;
        font-weight: bold;
        position: absolute;
        top: -10px;
        left: 10px;
        background-color: white;
      }
    }
  }
}

.custCredTop {
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  
  >.custCredSection {
    flex: 1;

    > .custCredExtend {
      padding: 10px 5px 5px 5px;
      margin: 15px 5px 5px 5px;
      position: relative;
      border: solid 1px #00000033;
      border-radius: 3px;

      > .custCredExtendTitle {
        width: auto;
        height: 20px;
        padding: 0 5px 0 5px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        top: -11px;
        left: 10px;
        position: absolute;
        background-color: #ffffffff;
      }

      // > .custCredExtendButtons {
      //   margin: 0 0 0 20px;
      //   display: flex;
      //   flex-direction: column;
      // }
    }
  }
}

.shipConSalesDisplay {
  height: 100%;
}

.lhdn-tin {
  display: flex;
  flex-direction: row;
}

</style>